var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataCard',{attrs:{"title":'Toplam Borç Tutarı',"data":_vm.numberConverter(_vm.reportCompanyData.totalCurrentCredit,'TRY'),"description":'Tüm Zamanlar',"loading":_vm.reportCompanyDataLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }